import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'

class Videos extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        this.loadscript()
    }
    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    render() {
        const { } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                    <div className="website">
                        <section className="banner page-banner position-relative pb-0">
                            <div className="overlay"></div>
                            <div className="container">
                                <div className="page-title text-center position-relative py-9">
                                    <h2 className="text-white text-uppercase mt-4">Videos</h2>
                                </div>
                            </div>
                        </section>
                        <section className="news-archive" style={{ padding: "50px 0px" }}>
                            <div className="container">
                                <div className="news-archive-inner">
                                    <div className="row gy-5">
                                        <div className="col-lg-12">
                                            <div className="news-left me-4 m-md-0">
                                                <div className="row g-md-5 gy-5">
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="blog-box border border-1 rounded-2 p-2 pb-2 text-center">
                                                            <iframe
                                                                width="100%"
                                                                height={369}
                                                                src="https://www.youtube.com/embed/WWBKrtKRCWk"
                                                                title="ITME Awards 2022 Pre Event Video"
                                                                frameBorder={0}
                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                referrerPolicy="strict-origin-when-cross-origin"
                                                                allowFullScreen=""
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="blog-box border border-1 rounded-2 p-2 pb-2 text-center">
                                                            <iframe
                                                                width="100%"
                                                                height={369}
                                                                src="https://www.youtube.com/embed/zzyYMMOUJX8"
                                                                title="ITME Awards 2022 Pre Event Video"
                                                                frameBorder={0}
                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                referrerPolicy="strict-origin-when-cross-origin"
                                                                allowFullScreen=""
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="blog-box border border-1 rounded-2 p-2 pb-2 text-center">
                                                            <iframe width="100%"
                                                                height={369} src="https://www.youtube.com/embed/GLlNBOithag" title="India ITME Society 40 Years&#39; Celebration &amp; Awards Ceremony" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="blog-box border border-1 rounded-2 p-2 pb-2 text-center">
                                                            <iframe width="100%"
                                                                height={369} src="https://www.youtube.com/embed/ZvNsMu6s6F4" title="India ITME Society 40 Years&#39; Celebration &amp; Awards Ceremony" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <br />
                    </div>
                </>

                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(Videos)
);
